import type { WorkspaceLayer } from 'map-3d/components/map-3d-sidebar/shared';

export type LayerActionItemProps = {
  layer: WorkspaceLayer;
  refetchFeatures: VoidFunction;
  onVisibilityToggle?: (nextShow: boolean) => void;
};

export enum LayerAction {
  Zoom = 'zoom',
  Edit = 'edit',
  ToggleVisibility = 'toggleVisibility',
  Info = 'info',
}
